angular.
module("dx.webapp.datetimeinput").
factory("dxDateUtils", function dateUtilsService() {
	"use strict";

	function getDateIfValid(dateString) {
		var date = new Date(dateString);
		return date.valueOf() > 0 ? date : null;
	}

	return {
		getDateIfValid: getDateIfValid,
	};
});
